// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hMid","content":"styles_content__3FsVi","tableWrap":"styles_tableWrap__1vyrA"};